export default "__VITE_ASSET__b7e85184__"